module.exports = __webpack_public_path__ + "static/mockapp-talk-log-52c0505efd86a04cade86dfaee241195.png";